export default __webpack_public_path__ + "static/email-templates-multiple-recipients-42cf0a53d516111461a4428087d27362.mp4";